import { FC, useEffect, useState } from 'react';
import styles from './AssignationModal.module.css';
import { Modal } from '../Modal';
import { SearchField } from '../SearchField';
import { CarCard } from '../CarCard';
import { Button } from '../Button';
import { ConfirmAlert } from './views';
import {
  assignVehicle,
  useVehicle,
  useVehicleList,
  Vehicle,
} from '../../services/vehicle';
import { Spinner } from '../Spinner';
import { PlaceCenter } from '../PlaceCenter';
import {
  FUEL_LEVEL,
  CAN_EV_STATE_OF_CHARGE,
  CAN_EV_DISTANCE_UNTIL_RECHARGE,
  OBD_EV_STATE_OF_CHARGE,
  OBD_EV_DISTANCE_UNTIL_RECHARGE,
} from './constants';
import { FormattedMessage } from 'react-intl';

interface AssignationModalProps {
  open?: boolean;
  onClose?: () => void;
}

export const AssignationModal: FC<AssignationModalProps> = (props) => {
  const { onClose } = props;
  const [selected, setSelected] = useState<Vehicle | null>(null);
  const [query, setQuery] = useState('');
  const [confirmOpen, setConfirmOpen] = useState(false);
  const { result, running, error } = useVehicleList();
  const { result: resultVehicle } = useVehicle();

  const onAssignClick = () => {
    if (!selected) return;

    if (selected.firstDriver) {
      return setConfirmOpen(true);
    } else {
      triggerAssign();
    }
  };

  const triggerAssign = () => {
    selected && assignVehicle(selected);
  };

  useEffect(() => {
    if (resultVehicle) onClose?.();
  }, [resultVehicle, onClose]);

  useEffect(() => {
    if (error) onClose?.();
  }, [error, onClose]);

  return (
    <Modal
      title={<FormattedMessage id="Vehicle.Assignation.Title" />}
      {...props}
    >
      {running ? (
        <PlaceCenter>
          <Spinner />
        </PlaceCenter>
      ) : (
        <div className={styles.container}>
          <label className={styles.searchLabel} htmlFor="vehicleSearch">
            <FormattedMessage id="Vehicle.Assign.Search" />
          </label>
          <SearchField
            fullWidth
            id="vehicleSearch"
            onChange={(e) => setQuery(e.target.value)}
            value={query}
          />
          <div className={styles.cars}>
            {result?.items
              ?.filter(
                (car) =>
                  car.name.toLowerCase().indexOf(query.toLocaleLowerCase()) > -1
              )
              .map((car) => (
                <CarCard
                  key={car.id}
                  vehicleName={car.name}
                  driverName={car.firstDriver?.fullName}
                  onClick={() => setSelected(car)}
                  active={selected?.id === car.id}
                  fuelLevel={car.inputs[FUEL_LEVEL]}
                  stateOfCharge={
                    car.inputs[CAN_EV_STATE_OF_CHARGE] ??
                    car.inputs[OBD_EV_STATE_OF_CHARGE]
                  }
                  distanceUntilRecharge={
                    car.inputs[CAN_EV_DISTANCE_UNTIL_RECHARGE] ??
                    car.inputs[OBD_EV_DISTANCE_UNTIL_RECHARGE]
                  }
                />
              ))}
          </div>
          {selected != null && (
            <Button onClick={onAssignClick} className={styles.modalAssignBtn}>
              <FormattedMessage id="Vehicle.Assign" />
            </Button>
          )}
          {selected != null && (
            <ConfirmAlert
              open={confirmOpen}
              onClose={() => setConfirmOpen(false)}
              onConfirm={triggerAssign}
            >
              {selected?.firstDriver && (
                <FormattedMessage
                  tagName="p"
                  id="Vehicle.Assign.Alert.Assigned"
                  values={{
                    driver: selected?.firstDriver.fullName,
                    vehicle: selected?.name,
                    b: (chunks) => <strong>{chunks}</strong>,
                  }}
                />
              )}
              <FormattedMessage tagName="p" id="Vehicle.Assign.Confirm" />
            </ConfirmAlert>
          )}
        </div>
      )}
    </Modal>
  );
};
